import { ApplicationError } from './errors';

export type MediaKind = 'image' | 'video';
export type MediaRole = 'reference' | 'haystack';

interface MediaSourceBase {
    id: string;
    kind: MediaKind;
    name: string;
}

export interface FileMediaSource extends MediaSourceBase {
    origin: 'file';
    file: File;
    previewUrl: string;
}

export interface UrlMediaSource extends MediaSourceBase {
    origin: 'url';
    url: string;
}

export type MediaSource = FileMediaSource | UrlMediaSource;

export function inferMediaKind(file: File): MediaKind | undefined {
    if (file.type.startsWith('image/')) return 'image';
    if (file.type.startsWith('video/')) return 'video';
    return undefined;
}

export function normalizeMediaUrl(value: string): string {
    const url = new URL(value.trim(), window.location.href);
    if (!['http:', 'https:'].includes(url.protocol)) {
        throw new ApplicationError('unsupportedProtocol');
    }
    return url.href;
}

export function getMediaSourceUrl(source: MediaSource): string {
    return source.origin === 'url' ? source.url : source.previewUrl;
}
